






import { Component, Prop, Vue } from 'vue-property-decorator';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const CI360Viewer = require('js-cloudimage-360-view/dist/ci360.service').default;

@Component
export default class Turntable extends Vue {
  @Prop() urls!: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private turntable: any;
  async mounted() {
    this.createTurntable();
  }

  created() {
    this.$nextTick(function() {
      window.addEventListener('resize', this.resizeTurntable);
    });
  }

  destroyed() {
    this.$nextTick(function() {
      window.removeEventListener('resize', this.resizeTurntable);
    });
    if (this.turntable) {
      this.turntable.stop();
    }
  }

  resizeTurntable() {
    this.turntable.update();
  }

  createTurntable() {
    this.$nextTick(function() {
      if (this.$refs.turntable) {
        if (this.turntable) {
          return;
        }
        this.turntable = new CI360Viewer(this.$refs.turntable);
      }
    });
  }
}
